import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import closeModal from '../../actions/Modals/closeModal'
import { requestSynchronization } from '../../actions/synchronize/synchronize'
import {
  fireToastError,
  fireToastSuccess,
} from '../../actions/toasts/fireToast'
import { Modals } from '../../containers/Modals/ModalContainer'
import i18n from '../../i18n'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import saveAirbnbPriceForm from '../../models/Integration/saveAirbnbPriceForm'
import { eachDay, format, getDay } from 'date-fns'
import { stopAsyncValidation } from 'redux-form'
import { isEmpty } from 'lodash'

function* submitForm(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveAirbnbPriceForm)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, saveAirbnbPriceForm),
      ),
    ])

    // values:
    //   availability: "available"
    // availability_sub_type: null
    // availability_type: "available"
    // closed_to_arrival_days: (7) [true, true, true, 1, true, true, true]
    // closed_to_departure_days: (7) [true, true, true, 1, true, true, true]
    // date: "2021-09-01"
    // dates: [{…}]
    // from: Wed Sep 01 2021 00:00:00 GMT+0200 (czas środkowoeuropejski letni) {}
    // max_nights: 12
    // min_nights: 10
    // notes: null
    // price: "100.00"
    // selectedRoom: {additionalBeds: "0", additionalEquipment: null, booking: false, bookingRoomId: undefined, city: "Świdnica", …}

    // const finishDate = format(addYears(new Date(), 2), 'YYYY-MM-DD')

    // yield Effects.call(
    //   service,
    //   action.values,
    // )

    const inInterval = []
    const outInterval = []

    const interval = eachDay(
      action.values.dates[0].from,
      action.values.dates[0].to,
    )

    const closedIn = action.values.closed_to_arrival_days
    const closedOut = action.values.closed_to_departure_days

    let intervalStartIn = null
    let intervalEndIn = null
    let intervalStartOut = null
    let intervalEndOut = null

    for (let i = 0; i < interval.length; i++) {
      const date = interval[i]

      if (closedIn[getDay(date)]) {
        if (intervalStartIn === null) {
          intervalStartIn = date
          intervalEndIn = date
        } else {
          intervalEndIn = date
        }
      } else {
        if (intervalStartIn && intervalEndIn) {
          inInterval.push(
            `${format(intervalStartIn, 'YYYY-MM-DD')}:${format(
              intervalEndIn,
              'YYYY-MM-DD',
            )}`,
          )
        }
        intervalStartIn = null
        intervalEndIn = null
      }
    }

    if (intervalStartIn && intervalEndIn) {
      inInterval.push(
        `${format(intervalStartIn, 'YYYY-MM-DD')}:${format(
          intervalEndIn,
          'YYYY-MM-DD',
        )}`,
      )
    }

    for (let i = 0; i < interval.length; i++) {
      const date = interval[i]

      if (closedOut[getDay(date)]) {
        if (intervalStartOut === null) {
          intervalStartOut = date
          intervalEndOut = date
        } else {
          intervalEndOut = date
        }
      } else {
        if (intervalStartOut && intervalEndOut) {
          outInterval.push(
            `${format(intervalStartOut, 'YYYY-MM-DD')}:${format(
              intervalEndOut,
              'YYYY-MM-DD',
            )}`,
          )
        }
        intervalStartOut = null
        intervalEndOut = null
      }
    }

    if (intervalStartOut && intervalEndOut) {
      outInterval.push(
        `${format(intervalStartOut, 'YYYY-MM-DD')}:${format(
          intervalEndOut,
          'YYYY-MM-DD',
        )}`,
      )
    }

    const operations = [
      {
        dates: `${format(action.values.dates[0].from, 'YYYY-MM-DD')}:${format(
          action.values.dates[0].to,
          'YYYY-MM-DD',
        )}`,
        daily_price:
          Number(action.values.price) === 0
            ? null
            : Number(action.values.price),
        min_nights:
          Number(action.values.min_nights) === 0
            ? null
            : action.values.min_nights,
        max_nights:
          Number(action.values.max_nights) === 0
            ? null
            : action.values.max_nights,
        // closed_to_arrival: !!action.values.closed_to_arrival_days[getDay(i)],
        // closed_to_departure: !!action.values.closed_to_departure_days[
        //   getDay(i)
        // ],
        closed_to_arrival: false,
        closed_to_departure: false,
      },
      {
        dates: inInterval,
        daily_price:
          Number(action.values.price) === 0
            ? null
            : Number(action.values.price),
        min_nights:
          Number(action.values.min_nights) === 0
            ? null
            : action.values.min_nights,
        max_nights:
          Number(action.values.max_nights) === 0
            ? null
            : action.values.max_nights,
        // closed_to_arrival: !!action.values.closed_to_arrival_days[getDay(i)],
        // closed_to_departure: !!action.values.closed_to_departure_days[
        //   getDay(i)
        // ],
        closed_to_arrival: true,
      },
      {
        dates: outInterval,
        daily_price:
          Number(action.values.price) === 0
            ? null
            : Number(action.values.price),
        min_nights:
          Number(action.values.min_nights) === 0
            ? null
            : action.values.min_nights,
        max_nights:
          Number(action.values.max_nights) === 0
            ? null
            : action.values.max_nights,
        // closed_to_arrival: !!action.values.closed_to_arrival_days[getDay(i)],
        // closed_to_departure: !!action.values.closed_to_departure_days[
        //   getDay(i)
        // ],
        closed_to_departure: true,
      },
    ].filter(d => !isEmpty(d.dates))

    const v: any = {
      id_room: action.values.selectedRoom.id,
      operations: operations,
    }

    yield Effects.call(service, v)

    yield Effects.delay(500)

    yield Effects.put({ type: IntegrationAction.RequestPrices })

    yield Effects.put(closeModal(Modals.OpenAirbnbPriceFormModal))

    yield Effects.put(
      fireToastSuccess(
        i18n.t('BBO_1494_submit_success'),
        5000,
        'Main',
        'SubmitSuccess',
      ),
    )
  } catch (e) {
    if (e.message === '412') {
      yield Effects.put(requestSynchronization())
    }

    console.error(e)

    yield put(
      stopAsyncValidation('ContentAirbnbPriceModalForm', {
        price: 'OUT_25_daily_price_error',
      }),
    )

    yield put({ type: IntegrationAction.SetLoadingPrice, payload: false })

    yield Effects.put(
      fireToastError(
        i18n.t('OUT_25_saving_error'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.SubmitPriceForm, submitForm)
}
